
const digest = '4e9a10d1ebf122d365775f83cc525a7ffce44ba3c04acc4461974ef45c87773b';
const classes = {"wrapper":"_wrapper_b1ld6_1","checkbox":"_checkbox_b1ld6_11","description":"_description_b1ld6_21","active":"_active_b1ld6_25","title":"_title_b1ld6_30","disabled":"_disabled_b1ld6_35"};
const css = `._wrapper_b1ld6_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  height: fit-content;
  font-family: Rubik, "sans-serif";
  gap: 7.5px;
}

._checkbox_b1ld6_11 {
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  background: url("/dist/icons/react/fakebox.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}

._description_b1ld6_21 {
  font-size: 12px;
}

._active_b1ld6_25 {
  background: url("/dist/icons/react/fakebox-checked.svg") no-repeat center;
  background-size: contain;
}

._title_b1ld6_30 {
  font-size: 14px;
  font-weight: 500;
}

._disabled_b1ld6_35 {
  cursor: not-allowed;
}
._disabled_b1ld6_35 ._checkbox_b1ld6_11 {
  opacity: 0.8;
  cursor: not-allowed;
}
._disabled_b1ld6_35 ._title_b1ld6_30 {
  color: #939393;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  